var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{staticClass:"posr"},[_c('v-layout',{staticClass:"dict__header",attrs:{"align-center":"","text-center":""}},[_c('span',{staticClass:"white--text mr-auto ml-2 subtitle-2",staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }